module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/brand/buzzfeed-ec5e2880ca187d1a8e3ecaaed3350fc1.svg";